export default {
  'home.email_placeholder': 'Email address',
  'home.password_placeholder': 'Password',
  'home.remember_me': 'Remember me',
  'home.logging_in': 'Logging in...',
  'home.login_button': 'Log in',
  'home.find_id': 'Find ID',
  'home.find_password': 'Find Password',
  'home.signup_with_email': 'Sign up with email',
  'home.sns_login_divider': 'Log in / Sign up with SNS',
  'home.social_login_failed': 'Social login failed.',
  'home.login_failed': 'Login failed.',
  'home.get_started': 'Get Started',
  'home.connection_complete': 'Connected!',
  'home.redirecting_dashboard': 'Redirecting to dashboard...',
  'home.go_back': '← Go back',
  'home.qr_link_copied': 'Link copied to clipboard',
  'home.qr_link_copy_failed': 'Copy failed. Please select and copy manually.',
};
